import { endpoints } from "config";

export const META_TITLE = "PepsiCo Shop";
export const META_DESCRIPTION =
  "Grow your business—we’ve got the products you want covered";
export const CANONICAL_URL_BASE = endpoints.web;
export const META_DEFAULT_OG_IMAGE = `${endpoints.cdn}/cdn-cgi/image/format=auto,metadata=copyright,width=625/static-images/pepsico-shop-icons/b2b-images/product-guarantee-section-image-v2.png`;
export const PRIMARY_COLOR = `#28458e`;
